<template>
  <a
    :href="url"
    :target="target"
    :class="[
      'owc-text-media-module-cta',
      'wb-button',
      `wb-button--${type}`,
      `wb-button--medium`,
      { 'wb-button--theme-dark': isDarkModeOn },
    ]"
  >
    {{ label }}
  </a>
</template>

<script lang="ts">
import Vue from 'vue';
import { TextMediaCtaComponent } from '@owc-packages/TextMediaModule/src/TextMediaModule';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';

/**
 * OWC CTA - this is a subcomponent for OWC TextMediaModule Component
 *
 * @vue-prop {Boolean} [darkMode=fase] - Dark Mode flag
 */
export default (Vue as TextMediaCtaComponent).extend({
  props: {
    darkMode: {
      type: Boolean,
      default: false,
    },
    ctaData: {
      type: Object,
      required: true,
    },
  },
  mixins: [OwcDataComponent],
  computed: {
    isDarkModeOn: function() {
      return this.darkMode;
    },
    type: function() {
      return this.ctaData.type;
    },
    url: function() {
      return this.ctaData.url;
    },
    label: function() {
      return this.ctaData.label;
    },
    target: function() {
      return this.ctaData.target;
    },
  },
});
</script>

<style lang="scss">
$moduleName: 'owc-text-media-module-cta';

.#{$moduleName} {
  width: 100%;

  @include breakpoint-from(mq3) {
    width: fit-content;
  }
}
</style>
